const broadcastCircle = () => {
    const elements = Array.from(document.querySelectorAll('[data-component="broadcast-circle"]'));
  
    elements.forEach((element) => {
        element.addEventListener('click', function(e){
            e.preventDefault();
            
            const popUp = element.dataset.popup;
            MicroModal.show(popUp);    
        });
    });
  };
  
  export default broadcastCircle;